<template>
  <v-app>
    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'App'
};
</script>

<style>
/* One background and font for every page, so nothing flashes white
   while a page loads. */
html,
body,
#app,
.v-application {
  background: #0A0E14 !important;
}

.v-application {
  font-family: 'Outfit', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif !important;
  color: #F1F3F6;
}

/* Vuetify dark surfaces in the site's colors */
.theme--dark.v-card,
.theme--dark.v-sheet,
.theme--dark.v-list,
.theme--dark.v-picker__body,
.theme--dark.v-date-picker-table {
  background-color: #151B25;
}

.theme--dark.v-overlay {
  background-color: rgba(5, 7, 10, 0.72) !important;
}

::selection {
  background: rgba(255, 122, 69, 0.35);
  color: #F1F3F6;
}

/* Thin dark scrollbars */
* {
  scrollbar-color: #2A3446 #0A0E14;
}

::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-track {
  background: #0A0E14;
}

::-webkit-scrollbar-thumb {
  background: #2A3446;
  border-radius: 10px;
  border: 2px solid #0A0E14;
}

::-webkit-scrollbar-thumb:hover {
  background: #3A4558;
}
</style>
